import { render, staticRenderFns } from "./MeetContactsList.vue?vue&type=template&id=bbf022c4&scoped=true"
import script from "./MeetContactsList.vue?vue&type=script&lang=js"
export * from "./MeetContactsList.vue?vue&type=script&lang=js"
import style0 from "./MeetContactsList.vue?vue&type=style&index=0&id=bbf022c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf022c4",
  null
  
)

export default component.exports